/**
 * Session flags for post-login announcement modals ("Maybe later"). Cleared on logout.
 * Keys are per `announcementKey` from `brandConfig.postLoginModal`.
 */

import brandConfig from '../../config/brandConfig';

/** @deprecated Legacy key for `timeshareListingWalkthrough`; kept for migration / clear on logout */
export const TIMESHARE_ANNOUNCEMENT_SESSION_DEFER_KEY =
  'ownerPortal:timeshareListingWalkthrough:sessionDeferred';

export function postLoginModalSessionDeferKey(announcementKey: string): string {
  return `ownerPortal:${announcementKey}:sessionDeferred`;
}

export function setPostLoginModalSessionDefer(announcementKey: string): void {
  try {
    sessionStorage.setItem(postLoginModalSessionDeferKey(announcementKey), '1');
  } catch {
    // ignore quota / private mode
  }
}

/** @deprecated Use `setPostLoginModalSessionDefer(announcementKey)` */
export function setTimeshareAnnouncementSessionDefer(): void {
  setPostLoginModalSessionDefer('timeshareListingWalkthrough');
}

export function clearTimeshareAnnouncementSessionDefer(): void {
  try {
    sessionStorage.removeItem(TIMESHARE_ANNOUNCEMENT_SESSION_DEFER_KEY);
  } catch {
    // ignore
  }
}

/** Clears legacy defer key and all keys for the current brand's `postLoginModal` entries. */
export function clearAllPostLoginModalSessionStorage(): void {
  clearTimeshareAnnouncementSessionDefer();
  try {
    brandConfig.postLoginModal?.forEach((m) => {
      sessionStorage.removeItem(postLoginModalSessionDeferKey(m.announcementKey));
    });
  } catch {
    // ignore
  }
}
